import { render, staticRenderFns } from "./GroupsSearchResultsTable.vue?vue&type=template&id=25220896&scoped=true&"
import script from "./GroupsSearchResultsTable.vue?vue&type=script&lang=ts&"
export * from "./GroupsSearchResultsTable.vue?vue&type=script&lang=ts&"
import style0 from "./GroupsSearchResultsTable.vue?vue&type=style&index=0&id=25220896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25220896",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDataTable,VRow})
